import { Action, Dispatch } from "redux";
import size from "lodash/size";
import ProjectService from "../../services/projectService";
import ModelService from "../../services/modelServices";
import { ActionTypes } from "./actionTypes";
import {
    IApplicationState,
    IUserModelsDetails,
    IProject, AppError,
    ErrorCode,
} from "../../models/applicationState";
import { createAction, createPayloadAction, IPayloadAction } from "./actionCreators";

export default interface IUserModelActions {
    loadUserModels(forceUpdate?: boolean): Promise<any>;
    deleteProject(project: IProject): Promise<void>;
    deleteUserModel(model: any, project: IProject): Promise<void>;
}

/**
 * Dispatches Load Project action and resolves with IProject
 * @param project - Project to load
 */
export function loadUserModels(forceUpdate?: boolean):
    (dispatch: Dispatch, getState: () => IApplicationState) => Promise<any> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const appState = getState();
        let loadedModels;
        if (forceUpdate || size(appState.loadModels) === 0) {
            const modelService = new ModelService();
            loadedModels = await modelService.getUserModels();
        } else if (appState.loadModels.length > 0) {
         loadedModels = appState.loadModels;
        }
        dispatch(loadAllModels(loadedModels));
        return loadedModels;
    };
}

export function deleteUserModel(model: IUserModelsDetails, project: IProject)
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const modelService = new ModelService();
    await modelService.deleteUserModel(model);
    if (project) {
     await this.deleteProject(project);
    }
    dispatch(deleteUserModelAction(model));
    };
}

export function deleteProject(project: IProject)
    : (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const appState = getState();
        const projectService = new ProjectService();

        // Lookup security token used to decrypt project settings
        const projectToken = appState.appSettings.securityTokens
            .find((securityToken) => securityToken.name === project.securityToken);

        if (!projectToken) {
            throw new AppError(ErrorCode.SecurityTokenNotFound, "Security Token Not Found");
        }

        const decryptedProject = await projectService.load(project, projectToken);
        dispatch(deleteProjectAction(decryptedProject));
    };
}

export interface ILoadUserModelsAction extends IPayloadAction<string, any> {
    type: ActionTypes.ALL_MODELS_SUCCESS;
}

/**
 * Delete project action type DELETE_MODEL_SUCCESS
 */
export interface IDeleteModelProjectAction extends IPayloadAction<string, IProject> {
    type: ActionTypes.DELETE_PROJECT_SUCCESS;
}

/**
 * Delete project action type DELETE_MODEL_SUCCESS
 */
export interface IDeleteUserModelAction extends IPayloadAction<string, IUserModelsDetails> {
    type: ActionTypes.DELETE_MODEL_SUCCESS;
}

export const loadAllModels = createPayloadAction<ILoadUserModelsAction>(ActionTypes.ALL_MODELS_SUCCESS);
/**
 * Instance of Delete Project action
 */
export const deleteProjectAction = createPayloadAction<IDeleteModelProjectAction>(ActionTypes.DELETE_PROJECT_SUCCESS);

export const deleteUserModelAction = createPayloadAction<IDeleteUserModelAction>(ActionTypes.DELETE_MODEL_SUCCESS);
